module.exports = __webpack_public_path__ + "cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cc.svg
// module id = 479
// module chunks = 0